"use strict";

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducer(state, action) {
  const {
    type,
    key,
    value,
    persist
  } = action;

  switch (type) {
    case 'add':
      return { ...state,
        [key]: {
          value,
          persist
        }
      };

    case 'clear':
      const {
        [key]: clearedKey,
        ...rest
      } = state;
      return { ...rest
      };

    case 'clear_all':
      return {};

    default:
      throw new Error();
  }
}

function getInitState(persistKey) {
  let persistedValues = {};

  try {
    persistedValues = JSON.parse(localStorage.getItem(persistKey)) || {};
  } catch (error) {
    console.warn(error);
  }

  return persistedValues;
}

const Provider = ({
  children,
  persistKey = 'simple_values'
}) => {
  const [state, dispatch] = (0, _react.useReducer)(reducer, getInitState(persistKey));
  (0, _react.useEffect)(() => {
    try {
      const persistValues = {};
      Object.keys(state).map(k => {
        if (state[k].persist) {
          persistValues[k] = {
            value: state[k].value,
            persist: true
          };
        }

        return k;
      });
      localStorage.setItem(persistKey, JSON.stringify(persistValues));
    } catch (error) {
      console.warn(error);
    }
  }, [state, persistKey]);

  const setValue = (key, value, persist = false) => {
    dispatch({
      type: 'add',
      key,
      value,
      persist
    });
  };

  const getValue = (key, defaultValue) => {
    if (state[key] !== undefined) {
      return state[key].value;
    } else {
      return defaultValue;
    }
  };

  const clearValue = key => {
    dispatch({
      type: 'clear',
      key
    });
  };

  const clearAll = () => {
    dispatch({
      type: 'clear_all'
    });
  };

  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: {
      setValue,
      getValue,
      clearValue,
      clearAll
    }
  }, children);
};

Provider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.any
} : {};
var _default = Provider;
exports.default = _default;
module.exports = exports.default;